export default __webpack_public_path__ + "images/sk-be58e557507f1468968917cb825153ab.svg";